import { Dispatch, SetStateAction } from 'react';
import { css } from '@emotion/react';
import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { useScheduleActionsContext } from '../../ScheduleActionsContext';
import { ScheduleActionsProvider } from '../../ScheduleActionsProvider';
import { ScheduleRequestContextProvider } from '../Context/ScheduleRequestContext';
import { useScheduleRequestContextValue } from '../hooks/use-schedule-request-context-value';
import { useScheduleRequestModalContextValue } from '../hooks/use-schedule-request-modal-context-value';
import { ScheduleRequestTray } from '../ScheduleRequestModal/ScheduleRequestWrappers/ScheduleRequestTray';
import { SchedulePulseRequestListItem } from './SchedulePulseRequestList/SchedulePulseRequestListItem';
import { ScheduleRequestFormManager } from './ScheduleRequestFormManager';

type ScheduleRequestListContentProps = {
  scheduleRequests: ScheduleRequest[];
  className?: string;
};

const WrappedScheduleRequestList = ({ scheduleRequests, className }: ScheduleRequestListContentProps) => {
  const { selectedScheduleRequest, setSelectedScheduleRequest, scheduleRequestModalContextValue } =
    useScheduleRequestModalContextValue({ refetchScheduleRequestList: () => {} });
  const { scheduleRequestModalProps } = scheduleRequestModalContextValue;
  const scheduleActionsContextValue = useScheduleActionsContext();

  const { providerValue } = useScheduleRequestContextValue({ refetchScheduleRequestList: () => {} });

  return (
    <>
      <ScheduleRequestContextProvider value={providerValue}>
        <Accordion className={className} css={styles.accordion}>
          {scheduleRequests.map((listItem) => (
            <SchedulePulseRequestListItem
              key={listItem.id}
              listItem={listItem}
              setSelectedScheduleRequest={
                setSelectedScheduleRequest as Dispatch<SetStateAction<ScheduleRequest | null>>
              }
              scheduleRequestModalProps={scheduleRequestModalProps}
            />
          ))}
        </Accordion>
      </ScheduleRequestContextProvider>
      {selectedScheduleRequest && (
        <ScheduleRequestFormManager
          wrapper={ScheduleRequestTray}
          scheduleRequestModalContextValue={scheduleRequestModalContextValue}
          selectedScheduleRequest={selectedScheduleRequest}
          scheduleActionsContextValue={scheduleActionsContextValue}
        />
      )}
    </>
  );
};

export const ScheduleRequestList = (props: ScheduleRequestListContentProps) => {
  return (
    <ScheduleActionsProvider>
      <WrappedScheduleRequestList {...props} />
    </ScheduleActionsProvider>
  );
};

const styles = {
  accordion: css`
    padding: ${theme.spacing(0.5, 0)};
    background-color: ${theme.colors.neutral5};
    overflow-y: auto;
  `,
};
